export function uniquifySvgIds(svgText, prefix) {
  const ids = [];
  let result = svgText.replace(/\bid="([^"]+)"/g, (_, id) => {
    ids.push(id);
    return `id="${prefix}-${id}"`;
  });

  ids.forEach((id) => {
    const escaped = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const replacements = [
      [new RegExp(`url\\(#${escaped}\\)`, "g"), `url(#${prefix}-${id})`],
      [new RegExp(`xlink:href="#${escaped}"`, "g"), `xlink:href="#${prefix}-${id}"`],
      [new RegExp(`href="#${escaped}"`, "g"), `href="#${prefix}-${id}"`],
    ];

    replacements.forEach(([pattern, replacement]) => {
      result = result.replace(pattern, replacement);
    });
  });

  return result;
}
